export enum PbiEvents {
  loaded = "loaded",
  pagedChanged = "pageChanged",
}
